import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/user/signup",
    name: "tenant",
    component: () => import("@/pages/tenant.vue"),
    meta: {
      title: 'MAP Group Asia',
      link: [
        {
          rel: "stylesheet preload",
          as: "style",
          crossorigin: "anonymous",
          type: "text/css",
          href: `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/css/main.min.css`,
        }
      ],
    }
  },
  {
    path:"/thankyou",
    name:"thankyou",
    component: () => import("@/pages/thankyou.vue"),
    meta: {
      title: 'MAP Group Asia',
      link: [
        {
          rel: "stylesheet preload",
          as: "style",
          crossorigin: "anonymous",
          type: "text/css",
          href: `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/css/main.min.css`,
        }
      ],
    }
  },
  {
    path:"/dataconsent",
    name:"dataconsent",
    component: () => import("@/pages/dataconsent.vue"),
    meta: {
      title: 'MAP Group Asia',
      link: [
        {
          rel: "stylesheet preload",
          as: "style",
          crossorigin: "anonymous",
          type: "text/css",
          href: `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/css/main.min.css`,
        }
      ],
    }
  },
  {
    path:"/terms-and-conditions",
    name:"terms-and-conditions",
    component: () => import("@/pages/terms-and-conditions.vue"),
    meta: {
      title: 'MAP Group Asia',
      link: [
        {
          rel: "stylesheet preload",
          as: "style",
          crossorigin: "anonymous",
          type: "text/css",
          href: `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/css/main.min.css`,
        }
      ],
    }
  },
  {
    path:"/privacy-policy",
    name:"privacy-policy",
    component: () => import("@/pages/privacy-policy.vue"),
    meta: {
      title: 'MAP Group Asia',
      link: [
        {
          rel: "stylesheet preload",
          as: "style",
          crossorigin: "anonymous",
          type: "text/css",
          href: `${process.env.VUE_APP_BASE_RESOURCE}/resources/v2/css/main.min.css`,
        }
      ],
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title
  const linkTags = to.meta.link || []
  linkTags.forEach((link) => {
    const linkTag = document.createElement('link')
    linkTag.rel = link.rel
    linkTag.href = link.href
    document.head.appendChild(linkTag)
  })
  const metaTags = to.meta.metaTags || []
  metaTags.forEach((metaTag) => {
    const meta = document.createElement('meta')
    meta.hid = metaTag.hid
    meta.name = metaTag.name
    meta.content = metaTag.content
    document.head.appendChild(meta)
  })
})

export default router;
